/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { parseBoolean } from '@jalik/form-parser'
import { Select, SelectProps } from '@mantine/core'

export type TaxIncludedFieldProps = Omit<SelectProps, 'data'>

function TaxIncludedField (props: TaxIncludedFieldProps) {
  const { name, ...others } = props
  const intl = useIntl()
  return (
    <FormField
      {...others}
      name={name}
      label={intl.formatMessage({
        id: 'taxes',
        defaultMessage: 'Taxes'
      })}
      parser={parseBoolean}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'tax_not_included',
            defaultMessage: 'HT'
          }),
          value: 'false'
        },
        {
          label: intl.formatMessage({
            id: 'tax_included',
            defaultMessage: 'TTC'
          }),
          value: 'true'
        }
      ]}
    />
  )
}

export default TaxIncludedField
